import { Component, Inject, OnInit } from '@angular/core';
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { AlertifyService } from 'src/app/services/alertify.service';
import { UserService } from 'src/app/services/user.service';
import { TomarFotoWebcamComponent } from '../../tomar-foto-webcam/tomar-foto-webcam.component';

@Component({
  selector: 'app-actualiza-foto-usuario',
  templateUrl: './actualiza-foto-usuario.component.html',
  styleUrls: ['./actualiza-foto-usuario.component.scss'],
})
export class ActualizaFotoUsuarioComponent implements OnInit {
  public fotoPerfil = '../../../../../assets/images/sinFoto.png';
  fileToUpload: File | null = null;
  cambioImg = false;

  constructor(
    private alertify: AlertifyService,
    private usrSvc: UserService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<ActualizaFotoUsuarioComponent>,
    public dialog: MatDialog
  ) {}

  ngOnInit(): void {
    console.log('Los datos del usuario son:', this.data);

    this.usrSvc.getFotoMini(this.data.id).subscribe((result) => {
      if (result) {
        if (result.url.length > 2) {
          this.fotoPerfil = result.url;
        }
      }
    });
  }

  showPreviewImage(event: any) {
    if (event.target.files && event.target.files[0]) {
      var reader = new FileReader();
      const files = event.target.files;
      var fileToUploadTmp = files.item(0);
      var size =
        fileToUploadTmp == null ? 0 : Math.round(fileToUploadTmp.size / 1024);
      console.log('size: ', size);
      var maxUploadSize = 2048;
      if (size <= maxUploadSize) {
        //  this.cambioEnLogo = true;
        reader.onload = (event: any) => {
          this.fileToUpload = files.item(0);
          this.fotoPerfil = event.target.result;
          this.cambioImg = true;
        };
        reader.readAsDataURL(event.target.files[0]);
      } else {
        this.alertify.error('La imagen debe ser menor a 2 mb');
      }
    }
  }

  uploadFileToActivity() {
    console.log('sube archivos');

    this.usrSvc
      .actualizarImagen(this.fileToUpload, this.data.id)
      .subscribe((res1) => {
        if (res1) {
          this.cambioImg = false;
          this.alertify.success('Imagen actualizada correctamente');
          this.dialogRef.close();
        } else {
          this.alertify.error('La imagen excede el límite permitido');
        }
      });
  }

  abrirCamara() {
    let dialogRef = this.dialog.open(TomarFotoWebcamComponent, {
      data: null,
    });
    dialogRef.afterClosed().subscribe((result) => {
      console.log('dialogo cerrado: ');
      console.log(result);

      if (result == null) {
        console.log('dialogo cerrado - no tomo foto');
      } else {
        console.log('dialogo cerrado - SI tomo foto');
        //  this.rutaImgRostro = result._imageAsDataUrl;
        this.cambioImg = true;
        this.fotoPerfil = result._imageAsDataUrl;
        const imageName = 'name.png';
        const imageBlob = this.dataURItoBlob(
          result._imageAsDataUrl.replace('data:image/jpeg;base64,', '')
        );
        this.fileToUpload = new File([imageBlob], imageName, {
          type: 'image/png',
        });
      }
    });
  }

  dataURItoBlob(dataURI: any) {
    const byteString = window.atob(dataURI);
    const arrayBuffer = new ArrayBuffer(byteString.length);
    const int8Array = new Uint8Array(arrayBuffer);
    for (let i = 0; i < byteString.length; i++) {
      int8Array[i] = byteString.charCodeAt(i);
    }
    const blob = new Blob([int8Array], { type: 'image/png' });
    return blob;
  }
}
